<script>
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import {useSecurityStore} from "@/stores/Security";
import useSharedMethod from "@/use/SharedMethod";
import StrHRVariables from "@/components/StrHRVariables.vue";
import useSharedData from "@/use/SharedData";

export default {
    name: "RecruitmentConfiguration",
    components: {StrHRVariables},
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        const {copyToClipboard} = useSharedMethod();
        
        const securityStore = useSecurityStore();
        
        
        onMounted(() => findAll());
        
        return {
            backgroundColor,
            securityStore,
            loading,
            configurations,
            copyToClipboard,
            save,
        }
    }
};
</script>

<template>
    
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_RECRUITMENT_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('common.email') }}</v-tab>
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="4">
                                <strong>{{ $t('recruitment_request.on_boarding_default_modal') }}</strong>
                                <w-server-autocomplete
                                    v-model="configurations[122].longg"
                                    api="boardingProcessModels"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="4">
                                <strong>{{ $t('recruitment_request.off_boarding_default_modal') }}</strong>
                                <w-server-autocomplete
                                    v-model="configurations[123].longg"
                                    api="boardingProcessModels"
                                    not-clearable
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <br/>
                    <v-tabs
                        class="tabs"
                        dense
                        color="teal"
                        vertical
                        :background-color="backgroundColor"
                    >
                        <v-tab>{{ $t('recruitment_request.candidate') }}</v-tab>
                        <v-tab>{{ $t('recruitment_request.evaluator') }}</v-tab>
                        <v-tab>{{ $t('recruitment_request.acquisition_position') }}</v-tab>
                        <v-tab>{{ $t('recruitment_request.email_on_off_boarding_task') }}</v-tab>
                        
                        <v-tab-item>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col cols="12">
                                        <str-h-r-variables module="RECRUITMENT_CANDIDATE"/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_object') }}</strong>
                                        <w-text-field
                                            v-model="configurations[116].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_body') }}</strong>
                                        <w-simple-text-area
                                            v-model="configurations[117].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col cols="12">
                                        <str-h-r-variables module="RECRUITMENT_PLANNING"/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_object') }}</strong>
                                        <w-text-field
                                            v-model="configurations[165].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_body') }}</strong>
                                        <w-simple-text-area
                                            v-model="configurations[166].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col cols="12">
                                        <str-h-r-variables module="RECRUITMENT_CANDIDATE"/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_object') }}</strong>
                                        <w-text-field
                                            v-model="configurations[118].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_body') }}</strong>
                                        <w-simple-text-area
                                            v-model="configurations[119].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item>
                            <v-container fluid>
                                <v-row dense>
                                    <v-col cols="12">
                                        <str-h-r-variables module="BOARDING_TASK"/>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_object') }}</strong>
                                        <w-text-field
                                            v-model="configurations[120].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <strong>{{ $t('common.email_body') }}</strong>
                                        <w-simple-text-area
                                            v-model="configurations[121].strr"
                                            not-clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>

<style lang="scss" scoped>
div.tabs [role="tab"] {
    justify-content: flex-start;
}
</style>